<template>
  <span class="s-label b-m-t-u">
    <slot/><span v-if="required" class="s-label__required color--status-error">*</span>
  </span>
</template>

<script>
export default {
  props: {
    required: { type: Boolean, default: false, required: false },
  },
}
</script>
